/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCreditApplicant_creditApplicant_CreditApplicant = { readonly __typename: 'CreditApplicant', readonly authEmail: string, readonly authId: string, readonly salesforceCreditIds: ReadonlyArray<string> };

export type GetCreditApplicant_Query = { readonly __typename: 'Query', readonly creditApplicant: GetCreditApplicant_creditApplicant_CreditApplicant };


export type GetCreditApplicantVariables = _Types.Exact<{ [key: string]: never; }>;


export type GetCreditApplicant = GetCreditApplicant_Query;


export const GetCreditApplicantDocument = gql`
    query GetCreditApplicant {
  creditApplicant {
    authEmail
    authId
    salesforceCreditIds
  }
}
    `;

/**
 * __useGetCreditApplicant__
 *
 * To run a query within a React component, call `useGetCreditApplicant` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditApplicant` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditApplicant({
 *   variables: {
 *   },
 * });
 */
export function useGetCreditApplicant(baseOptions?: Apollo.QueryHookOptions<GetCreditApplicant, GetCreditApplicantVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditApplicant, GetCreditApplicantVariables>(GetCreditApplicantDocument, options);
      }
export function useGetCreditApplicantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditApplicant, GetCreditApplicantVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditApplicant, GetCreditApplicantVariables>(GetCreditApplicantDocument, options);
        }
export function useGetCreditApplicantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreditApplicant, GetCreditApplicantVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCreditApplicant, GetCreditApplicantVariables>(GetCreditApplicantDocument, options);
        }
export type GetCreditApplicantHookResult = ReturnType<typeof useGetCreditApplicant>;
export type GetCreditApplicantLazyQueryHookResult = ReturnType<typeof useGetCreditApplicantLazyQuery>;
export type GetCreditApplicantSuspenseQueryHookResult = ReturnType<typeof useGetCreditApplicantSuspenseQuery>;
export type GetCreditApplicantQueryResult = Apollo.QueryResult<GetCreditApplicant, GetCreditApplicantVariables>;